// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnSetNewPassword {\n  margin-top: 40px !important;\n}\n.titleResetPassword {\n  margin-bottom: 30px;\n}", ""]);
// Exports
module.exports = exports;
